import { useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { useAppDispatch } from "../../../../hooks/useDispatch"
import { setShowAccountSetUp } from "../../../../redux/preferencesSlice"
import { SUPPRESSED } from "../../../../redux/types"
import { forceTokenRefresh } from "../../../../utils/auth/authUtils"
import { snackbar } from "../../../../utils/general/generalUtils"
import { deleteClientProtected } from "../../clients/clients"
import { REJECT_INVITE } from "../../urls/private"

interface IUseRejectInvites {
    isRejecting: boolean
    error: IAppError | undefined
    rejectInvite: () => Promise<void>
}

/**
 * Used to reject an invite to join an organisation
 * @returns {IUseRejectInvites} - loading and error states.
 */
const useRejectInvite = (): IUseRejectInvites => {
    const dispatch = useAppDispatch()
    const [isRejecting, setIsRejecting] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const rejectInvite = async (): Promise<void> => {
        try {
            setIsRejecting(true)
            await deleteClientProtected(REJECT_INVITE)
            forceTokenRefresh()
            dispatch(setShowAccountSetUp(SUPPRESSED))
            setError(undefined)
            snackbar("Invite rejected", "success")
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsRejecting(false)
        }
    }

    return {
        isRejecting,
        error,
        rejectInvite,
    }
}

export default useRejectInvite
